import SliderWithImpressions from '@/common/components/Slider/SliderWithImpressions';
import { compileArrayToPairs } from '@/common/utils/sharedUtils';
import CollectionTile from '@/modules/HomePage/components/FeaturedCollections/CollectionTile/CollectionTile';
import { HomepageFeaturedCollection } from 'generatedBfw/static';

import styles from './collectionsSlider.module.scss';

interface Props {
  collections: HomepageFeaturedCollection[];
}

const CollectionsSlider = ({ collections }: Props) => {
  const groupedCollections = compileArrayToPairs(collections);

  const keyExtractor = (
    collectionsGroup: [HomepageFeaturedCollection, HomepageFeaturedCollection],
  ) => {
    const singleCollectionKey = ({ collection, author }: HomepageFeaturedCollection) =>
      `${author.nick}/${collection.slug}`;

    return `${singleCollectionKey(collectionsGroup[0])}-${singleCollectionKey(
      collectionsGroup[1],
    )}`;
  };

  return (
    <SliderWithImpressions
      keyExtractor={keyExtractor}
      metadata={{ elementVariant: 'featured_collections' }}
      options={{
        className: styles.slider,
        slidesPerView: 1.25,
        breakpoints: {
          768: {
            slidesPerView: 1.75,
          },
          1024: {
            slidesPerView: 'auto',
          },
        },
      }}
      renderSlide={(collection, columnIndex, useSlideImpression) => (
        <div className={styles.slideWrapper}>
          <CollectionTile
            className={styles.tile}
            collection={collection[0]}
            position={columnIndex * 2 + 1}
            useSlideImpression={useSlideImpression}
          />
          <CollectionTile
            className={styles.tile}
            collection={collection[1]}
            position={columnIndex * 2 + 2}
            useSlideImpression={useSlideImpression}
          />
        </div>
      )}
      slideClassName={styles.slide}
      slides={groupedCollections}
    >
      <span className={styles.wrapperStart} slot="wrapper-start" />
      <span className={styles.wrapperEnd} slot="wrapper-end" />
    </SliderWithImpressions>
  );
};

export default CollectionsSlider;
